// @generated by protoc-gen-es v2.10.2 with parameter "target=ts"
// @generated from file inventory/v1/statistics_service.proto (package inventory.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv2";
import type { AssessmentScore } from "../../assessment/v1/assessment_score_pb";
import { file_assessment_v1_assessment_score } from "../../assessment/v1/assessment_score_pb";
import type { Timestamp } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { AICapability, AIPosture, ModelProviderRef } from "./ai_posture_pb";
import { file_inventory_v1_ai_posture } from "./ai_posture_pb";
import type { CompanyLifecycle } from "./company_lifecycle_pb";
import { file_inventory_v1_company_lifecycle } from "./company_lifecycle_pb";
import type { CompanyStatus } from "./company_status_pb";
import { file_inventory_v1_company_status } from "./company_status_pb";
import type { CompanySummary } from "./company_summary_pb";
import { file_inventory_v1_company_summary } from "./company_summary_pb";
import type { ControlCountStat } from "./control_service_pb";
import { file_inventory_v1_control_service } from "./control_service_pb";
import type { RiskLevel } from "./risk_pb";
import { file_inventory_v1_risk } from "./risk_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file inventory/v1/statistics_service.proto.
 */
export const file_inventory_v1_statistics_service: GenFile = /*@__PURE__*/
  fileDesc("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", [file_assessment_v1_assessment_score, file_google_protobuf_timestamp, file_inventory_v1_ai_posture, file_inventory_v1_company_lifecycle, file_inventory_v1_company_status, file_inventory_v1_company_summary, file_inventory_v1_control_service, file_inventory_v1_risk]);

/**
 * @generated from message inventory.v1.GetCompaniesCompliancesRequest
 */
export type GetCompaniesCompliancesRequest = Message<"inventory.v1.GetCompaniesCompliancesRequest"> & {
};

/**
 * Describes the message inventory.v1.GetCompaniesCompliancesRequest.
 * Use `create(GetCompaniesCompliancesRequestSchema)` to create a new message.
 */
export const GetCompaniesCompliancesRequestSchema: GenMessage<GetCompaniesCompliancesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 0);

/**
 * @generated from message inventory.v1.GetCompaniesCompliancesResponse
 */
export type GetCompaniesCompliancesResponse = Message<"inventory.v1.GetCompaniesCompliancesResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.CompanyCompliance companies = 1;
   */
  companies: CompanyCompliance[];
};

/**
 * Describes the message inventory.v1.GetCompaniesCompliancesResponse.
 * Use `create(GetCompaniesCompliancesResponseSchema)` to create a new message.
 */
export const GetCompaniesCompliancesResponseSchema: GenMessage<GetCompaniesCompliancesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 1);

/**
 * @generated from message inventory.v1.CompanyCompliance
 */
export type CompanyCompliance = Message<"inventory.v1.CompanyCompliance"> & {
  /**
   * @generated from field: string company_id = 1;
   */
  companyId: string;

  /**
   * @generated from field: string company_name = 2;
   */
  companyName: string;

  /**
   * @generated from field: inventory.v1.RiskLevel company_risk = 3;
   */
  companyRisk: RiskLevel;

  /**
   * @generated from field: inventory.v1.CompanyStatus status = 4;
   */
  status: CompanyStatus;

  /**
   * @generated from field: bool iso_27001 = 5;
   */
  iso27001: boolean;

  /**
   * @generated from field: bool soc_2 = 6;
   */
  soc2: boolean;

  /**
   * @generated from field: bool iso_27701 = 7;
   */
  iso27701: boolean;

  /**
   * @generated from field: repeated string tags = 8;
   */
  tags: string[];

  /**
   * @generated from field: inventory.v1.CompanyLifecycle lifecycle = 9;
   */
  lifecycle: CompanyLifecycle;
};

/**
 * Describes the message inventory.v1.CompanyCompliance.
 * Use `create(CompanyComplianceSchema)` to create a new message.
 */
export const CompanyComplianceSchema: GenMessage<CompanyCompliance> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 2);

/**
 * @generated from message inventory.v1.OngoingAssessmentsSummaryRequest
 */
export type OngoingAssessmentsSummaryRequest = Message<"inventory.v1.OngoingAssessmentsSummaryRequest"> & {
};

/**
 * Describes the message inventory.v1.OngoingAssessmentsSummaryRequest.
 * Use `create(OngoingAssessmentsSummaryRequestSchema)` to create a new message.
 */
export const OngoingAssessmentsSummaryRequestSchema: GenMessage<OngoingAssessmentsSummaryRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 3);

/**
 * @generated from message inventory.v1.OngoingAssessmentsSummaryResponse
 */
export type OngoingAssessmentsSummaryResponse = Message<"inventory.v1.OngoingAssessmentsSummaryResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.OngoingAssessmentSummary summaries = 1;
   */
  summaries: OngoingAssessmentSummary[];
};

/**
 * Describes the message inventory.v1.OngoingAssessmentsSummaryResponse.
 * Use `create(OngoingAssessmentsSummaryResponseSchema)` to create a new message.
 */
export const OngoingAssessmentsSummaryResponseSchema: GenMessage<OngoingAssessmentsSummaryResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 4);

/**
 * @generated from message inventory.v1.OngoingAssessmentSummary
 */
export type OngoingAssessmentSummary = Message<"inventory.v1.OngoingAssessmentSummary"> & {
  /**
   * @generated from field: string company_name = 1;
   */
  companyName: string;

  /**
   * @generated from field: inventory.v1.RiskLevel company_risk = 2;
   */
  companyRisk: RiskLevel;

  /**
   * @generated from field: string project_name = 3;
   */
  projectName: string;

  /**
   * @generated from field: google.protobuf.Timestamp start_date = 4;
   */
  startDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp end_date = 5;
   */
  endDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp questionnaires_start_date = 6;
   */
  questionnairesStartDate?: Timestamp;

  /**
   * @generated from field: google.protobuf.Timestamp questionnaires_end_date = 7;
   */
  questionnairesEndDate?: Timestamp;

  /**
   * @generated from field: repeated inventory.v1.ControlCountStat controls_by_status = 8;
   */
  controlsByStatus: ControlCountStat[];

  /**
   * @generated from field: int32 question_count = 9;
   */
  questionCount: number;

  /**
   * @generated from field: int32 assessed_control_count = 10;
   */
  assessedControlCount: number;

  /**
   * @generated from field: int32 automated_control_count = 11;
   */
  automatedControlCount: number;

  /**
   * Used to resolve the company logo. Empty when unknown.
   *
   * @generated from field: string company_website = 12;
   */
  companyWebsite: string;

  /**
   * Joins the summary to AssessmentInfo.ongoing_assessment_id.
   *
   * @generated from field: string ongoing_assessment_id = 13;
   */
  ongoingAssessmentId: string;
};

/**
 * Describes the message inventory.v1.OngoingAssessmentSummary.
 * Use `create(OngoingAssessmentSummarySchema)` to create a new message.
 */
export const OngoingAssessmentSummarySchema: GenMessage<OngoingAssessmentSummary> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 5);

/**
 * @generated from message inventory.v1.DaysCompaniesInAssessmentRequiredRequest
 */
export type DaysCompaniesInAssessmentRequiredRequest = Message<"inventory.v1.DaysCompaniesInAssessmentRequiredRequest"> & {
};

/**
 * Describes the message inventory.v1.DaysCompaniesInAssessmentRequiredRequest.
 * Use `create(DaysCompaniesInAssessmentRequiredRequestSchema)` to create a new message.
 */
export const DaysCompaniesInAssessmentRequiredRequestSchema: GenMessage<DaysCompaniesInAssessmentRequiredRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 6);

/**
 * @generated from message inventory.v1.DaysCompaniesInAssessmentRequiredResponse
 */
export type DaysCompaniesInAssessmentRequiredResponse = Message<"inventory.v1.DaysCompaniesInAssessmentRequiredResponse"> & {
  /**
   * @generated from field: repeated int32 days = 1;
   */
  days: number[];
};

/**
 * Describes the message inventory.v1.DaysCompaniesInAssessmentRequiredResponse.
 * Use `create(DaysCompaniesInAssessmentRequiredResponseSchema)` to create a new message.
 */
export const DaysCompaniesInAssessmentRequiredResponseSchema: GenMessage<DaysCompaniesInAssessmentRequiredResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 7);

/**
 * @generated from message inventory.v1.GetCountCompaniesBySeverityRequest
 */
export type GetCountCompaniesBySeverityRequest = Message<"inventory.v1.GetCountCompaniesBySeverityRequest"> & {
  /**
   * @generated from field: google.protobuf.Timestamp date = 1;
   */
  date?: Timestamp;
};

/**
 * Describes the message inventory.v1.GetCountCompaniesBySeverityRequest.
 * Use `create(GetCountCompaniesBySeverityRequestSchema)` to create a new message.
 */
export const GetCountCompaniesBySeverityRequestSchema: GenMessage<GetCountCompaniesBySeverityRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 8);

/**
 * @generated from message inventory.v1.GetCountCompaniesBySeverityResponse
 */
export type GetCountCompaniesBySeverityResponse = Message<"inventory.v1.GetCountCompaniesBySeverityResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.SeverityGroup groups = 1;
   */
  groups: SeverityGroup[];
};

/**
 * Describes the message inventory.v1.GetCountCompaniesBySeverityResponse.
 * Use `create(GetCountCompaniesBySeverityResponseSchema)` to create a new message.
 */
export const GetCountCompaniesBySeverityResponseSchema: GenMessage<GetCountCompaniesBySeverityResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 9);

/**
 * @generated from message inventory.v1.GetAlertsCountBySeverityTimeseriesRequest
 */
export type GetAlertsCountBySeverityTimeseriesRequest = Message<"inventory.v1.GetAlertsCountBySeverityTimeseriesRequest"> & {
};

/**
 * Describes the message inventory.v1.GetAlertsCountBySeverityTimeseriesRequest.
 * Use `create(GetAlertsCountBySeverityTimeseriesRequestSchema)` to create a new message.
 */
export const GetAlertsCountBySeverityTimeseriesRequestSchema: GenMessage<GetAlertsCountBySeverityTimeseriesRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 10);

/**
 * @generated from message inventory.v1.GetAlertsCountBySeverityTimeseriesResponse
 */
export type GetAlertsCountBySeverityTimeseriesResponse = Message<"inventory.v1.GetAlertsCountBySeverityTimeseriesResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.Timeseries timeseries = 1;
   */
  timeseries: Timeseries[];
};

/**
 * Describes the message inventory.v1.GetAlertsCountBySeverityTimeseriesResponse.
 * Use `create(GetAlertsCountBySeverityTimeseriesResponseSchema)` to create a new message.
 */
export const GetAlertsCountBySeverityTimeseriesResponseSchema: GenMessage<GetAlertsCountBySeverityTimeseriesResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 11);

/**
 * @generated from message inventory.v1.Timeseries
 */
export type Timeseries = Message<"inventory.v1.Timeseries"> & {
  /**
   * @generated from field: google.protobuf.Timestamp timestamp = 1;
   */
  timestamp?: Timestamp;

  /**
   * @generated from field: repeated inventory.v1.CountBySeverity values = 2;
   */
  values: CountBySeverity[];
};

/**
 * Describes the message inventory.v1.Timeseries.
 * Use `create(TimeseriesSchema)` to create a new message.
 */
export const TimeseriesSchema: GenMessage<Timeseries> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 12);

/**
 * @generated from message inventory.v1.CountBySeverity
 */
export type CountBySeverity = Message<"inventory.v1.CountBySeverity"> & {
  /**
   * @generated from field: inventory.v1.RiskLevel severity = 1;
   */
  severity: RiskLevel;

  /**
   * @generated from field: double total = 2;
   */
  total: number;
};

/**
 * Describes the message inventory.v1.CountBySeverity.
 * Use `create(CountBySeveritySchema)` to create a new message.
 */
export const CountBySeveritySchema: GenMessage<CountBySeverity> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 13);

/**
 * @generated from message inventory.v1.ListCompaniesWithMostAlertsRequest
 */
export type ListCompaniesWithMostAlertsRequest = Message<"inventory.v1.ListCompaniesWithMostAlertsRequest"> & {
  /**
   * @generated from field: optional int32 limit = 1;
   */
  limit?: number;
};

/**
 * Describes the message inventory.v1.ListCompaniesWithMostAlertsRequest.
 * Use `create(ListCompaniesWithMostAlertsRequestSchema)` to create a new message.
 */
export const ListCompaniesWithMostAlertsRequestSchema: GenMessage<ListCompaniesWithMostAlertsRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 14);

/**
 * @generated from message inventory.v1.ListCompaniesWithMostAlertsResponse
 */
export type ListCompaniesWithMostAlertsResponse = Message<"inventory.v1.ListCompaniesWithMostAlertsResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.CompanyWithAlerts companies = 1;
   */
  companies: CompanyWithAlerts[];
};

/**
 * Describes the message inventory.v1.ListCompaniesWithMostAlertsResponse.
 * Use `create(ListCompaniesWithMostAlertsResponseSchema)` to create a new message.
 */
export const ListCompaniesWithMostAlertsResponseSchema: GenMessage<ListCompaniesWithMostAlertsResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 15);

/**
 * @generated from message inventory.v1.CompanyWithAlerts
 */
export type CompanyWithAlerts = Message<"inventory.v1.CompanyWithAlerts"> & {
  /**
   * @generated from field: inventory.v1.CompanySummary company = 1;
   */
  company?: CompanySummary;

  /**
   * @generated from field: repeated inventory.v1.CountBySeverity values = 2;
   */
  values: CountBySeverity[];
};

/**
 * Describes the message inventory.v1.CompanyWithAlerts.
 * Use `create(CompanyWithAlertsSchema)` to create a new message.
 */
export const CompanyWithAlertsSchema: GenMessage<CompanyWithAlerts> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 16);

/**
 * @generated from message inventory.v1.LobCount
 */
export type LobCount = Message<"inventory.v1.LobCount"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: inventory.v1.RiskLevel risk = 3;
   */
  risk: RiskLevel;
};

/**
 * Describes the message inventory.v1.LobCount.
 * Use `create(LobCountSchema)` to create a new message.
 */
export const LobCountSchema: GenMessage<LobCount> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 17);

/**
 * @generated from message inventory.v1.SeverityGroup
 */
export type SeverityGroup = Message<"inventory.v1.SeverityGroup"> & {
  /**
   * @generated from field: inventory.v1.RiskLevel severity = 1;
   */
  severity: RiskLevel;

  /**
   * @generated from field: int32 total_companies = 2;
   */
  totalCompanies: number;

  /**
   * @generated from field: repeated inventory.v1.LobCount lobs = 3;
   */
  lobs: LobCount[];
};

/**
 * Describes the message inventory.v1.SeverityGroup.
 * Use `create(SeverityGroupSchema)` to create a new message.
 */
export const SeverityGroupSchema: GenMessage<SeverityGroup> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 18);

/**
 * @generated from message inventory.v1.ListTopModelProvidersRequest
 */
export type ListTopModelProvidersRequest = Message<"inventory.v1.ListTopModelProvidersRequest"> & {
  /**
   * @generated from field: optional int32 limit = 1;
   */
  limit?: number;
};

/**
 * Describes the message inventory.v1.ListTopModelProvidersRequest.
 * Use `create(ListTopModelProvidersRequestSchema)` to create a new message.
 */
export const ListTopModelProvidersRequestSchema: GenMessage<ListTopModelProvidersRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 19);

/**
 * @generated from message inventory.v1.ListTopModelProvidersResponse
 */
export type ListTopModelProvidersResponse = Message<"inventory.v1.ListTopModelProvidersResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.ModelProviderRanking top_providers = 1;
   */
  topProviders: ModelProviderRanking[];

  /**
   * @generated from field: int32 other_providers_count = 2;
   */
  otherProvidersCount: number;

  /**
   * @generated from field: int32 other_third_party_count = 3;
   */
  otherThirdPartyCount: number;
};

/**
 * Describes the message inventory.v1.ListTopModelProvidersResponse.
 * Use `create(ListTopModelProvidersResponseSchema)` to create a new message.
 */
export const ListTopModelProvidersResponseSchema: GenMessage<ListTopModelProvidersResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 20);

/**
 * @generated from message inventory.v1.ModelProviderRanking
 */
export type ModelProviderRanking = Message<"inventory.v1.ModelProviderRanking"> & {
  /**
   * @generated from field: inventory.v1.ModelProviderRef provider = 1;
   */
  provider?: ModelProviderRef;

  /**
   * @generated from field: int32 third_party_count = 2;
   */
  thirdPartyCount: number;
};

/**
 * Describes the message inventory.v1.ModelProviderRanking.
 * Use `create(ModelProviderRankingSchema)` to create a new message.
 */
export const ModelProviderRankingSchema: GenMessage<ModelProviderRanking> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 21);

/**
 * @generated from message inventory.v1.ListThirdPartyCountsByAICapabilityRequest
 */
export type ListThirdPartyCountsByAICapabilityRequest = Message<"inventory.v1.ListThirdPartyCountsByAICapabilityRequest"> & {
};

/**
 * Describes the message inventory.v1.ListThirdPartyCountsByAICapabilityRequest.
 * Use `create(ListThirdPartyCountsByAICapabilityRequestSchema)` to create a new message.
 */
export const ListThirdPartyCountsByAICapabilityRequestSchema: GenMessage<ListThirdPartyCountsByAICapabilityRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 22);

/**
 * @generated from message inventory.v1.ListThirdPartyCountsByAICapabilityResponse
 */
export type ListThirdPartyCountsByAICapabilityResponse = Message<"inventory.v1.ListThirdPartyCountsByAICapabilityResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.AICapabilityRanking rankings = 1;
   */
  rankings: AICapabilityRanking[];
};

/**
 * Describes the message inventory.v1.ListThirdPartyCountsByAICapabilityResponse.
 * Use `create(ListThirdPartyCountsByAICapabilityResponseSchema)` to create a new message.
 */
export const ListThirdPartyCountsByAICapabilityResponseSchema: GenMessage<ListThirdPartyCountsByAICapabilityResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 23);

/**
 * @generated from message inventory.v1.AICapabilityRanking
 */
export type AICapabilityRanking = Message<"inventory.v1.AICapabilityRanking"> & {
  /**
   * @generated from field: inventory.v1.AICapability capability = 1;
   */
  capability: AICapability;

  /**
   * @generated from field: int32 third_party_count = 2;
   */
  thirdPartyCount: number;
};

/**
 * Describes the message inventory.v1.AICapabilityRanking.
 * Use `create(AICapabilityRankingSchema)` to create a new message.
 */
export const AICapabilityRankingSchema: GenMessage<AICapabilityRanking> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 24);

/**
 * @generated from message inventory.v1.ListThirdPartyCountsByAIPostureRequest
 */
export type ListThirdPartyCountsByAIPostureRequest = Message<"inventory.v1.ListThirdPartyCountsByAIPostureRequest"> & {
};

/**
 * Describes the message inventory.v1.ListThirdPartyCountsByAIPostureRequest.
 * Use `create(ListThirdPartyCountsByAIPostureRequestSchema)` to create a new message.
 */
export const ListThirdPartyCountsByAIPostureRequestSchema: GenMessage<ListThirdPartyCountsByAIPostureRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 25);

/**
 * @generated from message inventory.v1.ListThirdPartyCountsByAIPostureResponse
 */
export type ListThirdPartyCountsByAIPostureResponse = Message<"inventory.v1.ListThirdPartyCountsByAIPostureResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.AIPostureRanking rankings = 1;
   */
  rankings: AIPostureRanking[];
};

/**
 * Describes the message inventory.v1.ListThirdPartyCountsByAIPostureResponse.
 * Use `create(ListThirdPartyCountsByAIPostureResponseSchema)` to create a new message.
 */
export const ListThirdPartyCountsByAIPostureResponseSchema: GenMessage<ListThirdPartyCountsByAIPostureResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 26);

/**
 * @generated from message inventory.v1.AIPostureRanking
 */
export type AIPostureRanking = Message<"inventory.v1.AIPostureRanking"> & {
  /**
   * @generated from field: inventory.v1.AIPosture posture = 1;
   */
  posture: AIPosture;

  /**
   * @generated from field: int32 third_party_count = 2;
   */
  thirdPartyCount: number;
};

/**
 * Describes the message inventory.v1.AIPostureRanking.
 * Use `create(AIPostureRankingSchema)` to create a new message.
 */
export const AIPostureRankingSchema: GenMessage<AIPostureRanking> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 27);

/**
 * @generated from message inventory.v1.ListDiscoverySolutionCountsByAIPostureRequest
 */
export type ListDiscoverySolutionCountsByAIPostureRequest = Message<"inventory.v1.ListDiscoverySolutionCountsByAIPostureRequest"> & {
};

/**
 * Describes the message inventory.v1.ListDiscoverySolutionCountsByAIPostureRequest.
 * Use `create(ListDiscoverySolutionCountsByAIPostureRequestSchema)` to create a new message.
 */
export const ListDiscoverySolutionCountsByAIPostureRequestSchema: GenMessage<ListDiscoverySolutionCountsByAIPostureRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 28);

/**
 * @generated from message inventory.v1.ListDiscoverySolutionCountsByAIPostureResponse
 */
export type ListDiscoverySolutionCountsByAIPostureResponse = Message<"inventory.v1.ListDiscoverySolutionCountsByAIPostureResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.DiscoveryAIPostureRanking rankings = 1;
   */
  rankings: DiscoveryAIPostureRanking[];
};

/**
 * Describes the message inventory.v1.ListDiscoverySolutionCountsByAIPostureResponse.
 * Use `create(ListDiscoverySolutionCountsByAIPostureResponseSchema)` to create a new message.
 */
export const ListDiscoverySolutionCountsByAIPostureResponseSchema: GenMessage<ListDiscoverySolutionCountsByAIPostureResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 29);

/**
 * @generated from message inventory.v1.DiscoveryAIPostureRanking
 */
export type DiscoveryAIPostureRanking = Message<"inventory.v1.DiscoveryAIPostureRanking"> & {
  /**
   * @generated from field: inventory.v1.AIPosture posture = 1;
   */
  posture: AIPosture;

  /**
   * @generated from field: int32 solution_count = 2;
   */
  solutionCount: number;
};

/**
 * Describes the message inventory.v1.DiscoveryAIPostureRanking.
 * Use `create(DiscoveryAIPostureRankingSchema)` to create a new message.
 */
export const DiscoveryAIPostureRankingSchema: GenMessage<DiscoveryAIPostureRanking> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 30);

/**
 * @generated from message inventory.v1.ListAIThirdPartyCountsByAssessmentScoreRequest
 */
export type ListAIThirdPartyCountsByAssessmentScoreRequest = Message<"inventory.v1.ListAIThirdPartyCountsByAssessmentScoreRequest"> & {
};

/**
 * Describes the message inventory.v1.ListAIThirdPartyCountsByAssessmentScoreRequest.
 * Use `create(ListAIThirdPartyCountsByAssessmentScoreRequestSchema)` to create a new message.
 */
export const ListAIThirdPartyCountsByAssessmentScoreRequestSchema: GenMessage<ListAIThirdPartyCountsByAssessmentScoreRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 31);

/**
 * @generated from message inventory.v1.ListAIThirdPartyCountsByAssessmentScoreResponse
 */
export type ListAIThirdPartyCountsByAssessmentScoreResponse = Message<"inventory.v1.ListAIThirdPartyCountsByAssessmentScoreResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.AssessmentScoreRanking rankings = 1;
   */
  rankings: AssessmentScoreRanking[];
};

/**
 * Describes the message inventory.v1.ListAIThirdPartyCountsByAssessmentScoreResponse.
 * Use `create(ListAIThirdPartyCountsByAssessmentScoreResponseSchema)` to create a new message.
 */
export const ListAIThirdPartyCountsByAssessmentScoreResponseSchema: GenMessage<ListAIThirdPartyCountsByAssessmentScoreResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 32);

/**
 * @generated from message inventory.v1.AssessmentScoreRanking
 */
export type AssessmentScoreRanking = Message<"inventory.v1.AssessmentScoreRanking"> & {
  /**
   * @generated from field: assessment.v1.AssessmentScore score = 1;
   */
  score: AssessmentScore;

  /**
   * @generated from field: int32 third_party_count = 2;
   */
  thirdPartyCount: number;
};

/**
 * Describes the message inventory.v1.AssessmentScoreRanking.
 * Use `create(AssessmentScoreRankingSchema)` to create a new message.
 */
export const AssessmentScoreRankingSchema: GenMessage<AssessmentScoreRanking> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 33);

/**
 * @generated from message inventory.v1.ListAIThirdPartyAlertCountsBySeverityRequest
 */
export type ListAIThirdPartyAlertCountsBySeverityRequest = Message<"inventory.v1.ListAIThirdPartyAlertCountsBySeverityRequest"> & {
};

/**
 * Describes the message inventory.v1.ListAIThirdPartyAlertCountsBySeverityRequest.
 * Use `create(ListAIThirdPartyAlertCountsBySeverityRequestSchema)` to create a new message.
 */
export const ListAIThirdPartyAlertCountsBySeverityRequestSchema: GenMessage<ListAIThirdPartyAlertCountsBySeverityRequest> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 34);

/**
 * @generated from message inventory.v1.ListAIThirdPartyAlertCountsBySeverityResponse
 */
export type ListAIThirdPartyAlertCountsBySeverityResponse = Message<"inventory.v1.ListAIThirdPartyAlertCountsBySeverityResponse"> & {
  /**
   * @generated from field: repeated inventory.v1.CountBySeverity values = 1;
   */
  values: CountBySeverity[];
};

/**
 * Describes the message inventory.v1.ListAIThirdPartyAlertCountsBySeverityResponse.
 * Use `create(ListAIThirdPartyAlertCountsBySeverityResponseSchema)` to create a new message.
 */
export const ListAIThirdPartyAlertCountsBySeverityResponseSchema: GenMessage<ListAIThirdPartyAlertCountsBySeverityResponse> = /*@__PURE__*/
  messageDesc(file_inventory_v1_statistics_service, 35);

/**
 * @generated from service inventory.v1.StatisticsService
 */
export const StatisticsService: GenService<{
  /**
   * @generated from rpc inventory.v1.StatisticsService.GetAlertsCountBySeverityTimeseries
   */
  getAlertsCountBySeverityTimeseries: {
    methodKind: "unary";
    input: typeof GetAlertsCountBySeverityTimeseriesRequestSchema;
    output: typeof GetAlertsCountBySeverityTimeseriesResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.StatisticsService.ListCompaniesWithMostAlerts
   */
  listCompaniesWithMostAlerts: {
    methodKind: "unary";
    input: typeof ListCompaniesWithMostAlertsRequestSchema;
    output: typeof ListCompaniesWithMostAlertsResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.StatisticsService.GetCountCompaniesBySeverity
   */
  getCountCompaniesBySeverity: {
    methodKind: "unary";
    input: typeof GetCountCompaniesBySeverityRequestSchema;
    output: typeof GetCountCompaniesBySeverityResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.StatisticsService.DaysCompaniesInAssessmentRequired
   */
  daysCompaniesInAssessmentRequired: {
    methodKind: "unary";
    input: typeof DaysCompaniesInAssessmentRequiredRequestSchema;
    output: typeof DaysCompaniesInAssessmentRequiredResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.StatisticsService.OngoingAssessmentsSummary
   */
  ongoingAssessmentsSummary: {
    methodKind: "unary";
    input: typeof OngoingAssessmentsSummaryRequestSchema;
    output: typeof OngoingAssessmentsSummaryResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.StatisticsService.GetCompaniesCompliances
   */
  getCompaniesCompliances: {
    methodKind: "unary";
    input: typeof GetCompaniesCompliancesRequestSchema;
    output: typeof GetCompaniesCompliancesResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.StatisticsService.ListTopModelProviders
   */
  listTopModelProviders: {
    methodKind: "unary";
    input: typeof ListTopModelProvidersRequestSchema;
    output: typeof ListTopModelProvidersResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.StatisticsService.ListThirdPartyCountsByAICapability
   */
  listThirdPartyCountsByAICapability: {
    methodKind: "unary";
    input: typeof ListThirdPartyCountsByAICapabilityRequestSchema;
    output: typeof ListThirdPartyCountsByAICapabilityResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.StatisticsService.ListThirdPartyCountsByAIPosture
   */
  listThirdPartyCountsByAIPosture: {
    methodKind: "unary";
    input: typeof ListThirdPartyCountsByAIPostureRequestSchema;
    output: typeof ListThirdPartyCountsByAIPostureResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.StatisticsService.ListDiscoverySolutionCountsByAIPosture
   */
  listDiscoverySolutionCountsByAIPosture: {
    methodKind: "unary";
    input: typeof ListDiscoverySolutionCountsByAIPostureRequestSchema;
    output: typeof ListDiscoverySolutionCountsByAIPostureResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.StatisticsService.ListAIThirdPartyCountsByAssessmentScore
   */
  listAIThirdPartyCountsByAssessmentScore: {
    methodKind: "unary";
    input: typeof ListAIThirdPartyCountsByAssessmentScoreRequestSchema;
    output: typeof ListAIThirdPartyCountsByAssessmentScoreResponseSchema;
  },
  /**
   * @generated from rpc inventory.v1.StatisticsService.ListAIThirdPartyAlertCountsBySeverity
   */
  listAIThirdPartyAlertCountsBySeverity: {
    methodKind: "unary";
    input: typeof ListAIThirdPartyAlertCountsBySeverityRequestSchema;
    output: typeof ListAIThirdPartyAlertCountsBySeverityResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_inventory_v1_statistics_service, 0);

